/* eslint-disable @typescript-eslint/no-unsafe-member-access */
const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);

export const FondsRebondService = {
    async pushData(request: any, captchaToken: string) {
        const formData = new FormData();
        if (request.type === 1) {
            request.filesWorkerList.forEach((i: File) => {
                formData.append('files', i);
            });
        } else {
            request.filesAccord.forEach((i: File) => {
                formData.append('files', i);
            });

            request.filesAttestation.forEach((i: File) => {
                formData.append('files', i);
            });

            request.filesPlan.forEach((i: File) => {
                formData.append('files', i);
            });

            request.filesPositiveProof.forEach((i: File) => {
                formData.append('files', i);
            });
        }

        request.filesOther.forEach((i: File) => {
            formData.append('files', i);
        });

        for (const key in request) {
            const isCuratorWorkerField =
                request.type === 1 &&
                (key === 'nameWorker' || key === 'surnameWorker');

            if (
                Object.prototype.hasOwnProperty.call(request, key) &&
                !key.match(/files/g) &&
                !isCuratorWorkerField
            ) {
                formData.append(key, request[key]);
            }
        }

        formData.set('captchaToken', captchaToken);

        const response = await fetch('/api/FondsRebond/PushData', {
            method: 'POST',
            body: formData,
            headers: headers,
        });

        return await response.json();
    },
};
